<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :min-width="getMenuWidth()"
    max-height="500"
    offset-y
    nudge-top="15"
    tile
    elevation="2"
    attach="#certSelectorDropdown"
    ref="certSelectorDropdown"
    :nudge-left="getNudgeWidth()"
    :disabled="disabled"
    id="certSelectorDropdown"
    role="listbox"
  >
    <template v-slot:activator="{ on }">
      <button
        @keydown.space="focusOnFirst()"
        @click="focusOnFirst()"
        @keydown.up.prevent="focusOnFirst()"
        @keydown.down.prevent="focusOnFirst()"
        id="certSelectorDropdown"
        data-test="select-certificate"
        v-on="on"
        class="v-input v-input--select certificate-select-button select noselect"
        :disabled="disabled"
        role="combobox"
        @focus="focused1 = true"
        @blur="focused1 = false"
        :class="{
          focused: focused1,
        }"
        aria-controls="certSelectorDropdown"
        :aria-expanded="menu ? 'true' : 'false'"
        :aria-activedescendant="certId && selectedSyllabus && menu ? `cert-${certId}-${selectedSyllabus}` : ''"
        :aria-label="$t('certificate_label')"
        aria-required="true"
        :aria-readonly="disabled"
        aria-autocomplete="none"
        aria-haspopup="listbox"
      >
        <span style="font-size: 1rem">
          {{ certificateTextfieldValue || $t("certificate_chooser.1.2") }}
        </span>
        <v-icon style="">$vuetify.icons.menuDown</v-icon>
      </button>
    </template>

    <v-card tile height="100%" class="card dropdown" id="certSelector">
      <section class="grid">
        <div v-for="owner in owners" :key="owner.shortname">
          <div class="exam-logo-container">
            <div>
              <img
                :src="owner.logo"
                v-if="owner.logo"
                class="exam-logo vertical-center noselect"
                :alt="`${owner.shortname} Logo`"
                aria-hidden="true"
              />
              <span class="vertical-center exam-owner-text noselect">{{ owner.shortname }}</span>
            </div>
          </div>
          <template v-if="owner.certs != null">
            <div v-for="(scheme, certId) in owner.certs" :key="scheme.shortname">
              <template v-if="!scheme.constraints || !scheme.constraints.hideListing">
                <div
                  role="option"
                  :aria-selected="selectedCertificate?.name === scheme.name && selectedSyllabus === syllabus_version"
                  v-for="(syllabus, syllabus_version) in scheme.syllabi"
                  :key="syllabus_version"
                  v-on:click="
                    setCertificate({
                      cert: scheme,
                      syllabus: syllabus_version,
                      cert_id: certId,
                      logo: owner.logo,
                    })
                  "
                  class="exam-scheme-text noselect"
                  tabindex="0"
                  @keydown.enter="
                    setCertificate({
                      cert: scheme,
                      syllabus: syllabus_version,
                      cert_id: certId,
                      logo: owner.logo,
                    })
                  "
                  @keydown.space.prevent="
                    setCertificate({
                      cert: scheme,
                      syllabus: syllabus_version,
                      cert_id: certId,
                      logo: owner.logo,
                    })
                  "
                  @keydown.down.prevent="focusOnNext($event)"
                  @keydown.up.prevent="focusOnPrevious($event)"
                  :id="`cert-${certId}-${syllabus_version}`"
                  data-test="option-certificate"
                  :class="
                    selectedCertificate?.name === scheme.name && selectedSyllabus === syllabus_version
                      ? 'exam-scheme-text--selected'
                      : ''
                  "
                >
                  <span>{{ cutShortname(scheme.shortname, owner.shortname) }}</span>
                  <span v-if="Object.keys(scheme.syllabi).length > 1">, Syllabus {{ syllabus_version }}</span>
                </div>
              </template>
            </div>
          </template>
        </div>
      </section>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "ExamSelectorDropdown",
  props: {
    owners: Object,
    title: String,
    label: String,
    inputError: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      menu: false,
      focused1: false,
      uiColor: this.$store.getters["registration/uiColor"],
    };
  },
  methods: {
    cutShortname(shortname, owner) {
      if (shortname.startsWith(owner) && !shortname.startsWith("CMP")) {
        return shortname.substr(shortname.indexOf(" ") + 1);
      } else {
        return shortname;
      }
    },
    getNudgeWidth() {
      let width = this.getMenuWidth();
      if (width < 600 || (typeof window !== "undefined" && window.innerWidth < 961)) {
        return 0;
      } else if (width < 900) {
        return width / 2.7;
      } else {
        return width / 2.2;
      }
    },
    getMenuWidth() {
      if (typeof window !== "undefined") {
        if (window && window.innerWidth < 790) {
          return 290;
        } else if (window && window.innerWidth < 1100) {
          return 650;
        } else return 950;
      } else return 950;
    },
    setCertificate(certificate) {
      this.certificateExpired = false;
      this.selectedCertificate = certificate.cert;
      this.selectedSyllabus = certificate.syllabus;
      this.certId = certificate.cert_id;
      this.logo = certificate.logo;
      if (this.selectedCountry && !Object.keys(certificate.cert.countries).includes(this.selectedCountry)) {
        this.selectedCountry = "";
      }
      if (
        certificate.cert.requirements.admissionRequested &&
        certificate.cert.requirements.admissionRequested.requiredResources
      ) {
        this.requiredResources = certificate.cert.requirements.admissionRequested.requiredResources;
      } else {
        this.requiredResources = null;
      }
      if (this.$store.getters["registration/certificateValidTo"]) {
        var dayTomorrow = new Date();
        dayTomorrow.setDate(dayTomorrow.getDate() + 1);
        var validTo = new Date(this.$store.getters["registration/certificateValidTo"]);
        if (dayTomorrow > validTo) {
          this.certificateExpired = true;
        }
      }
      if (!this.examPreloaded) {
        this.$store.dispatch("registration/updateDate", null);
        this.$store.dispatch("registration/updateTime", null);
      }
    },
    focusOnFirst() {
      if (this.menu) {
        this.menu = false;
        const dropdown = document.getElementById("certSelectorDropdown");
        if (dropdown) {
          dropdown.focus();
        }
        return;
      }
      const waitForTabables = () => {
        return new Promise((resolve) => {
          const interval = setInterval(() => {
            const tabables = document.querySelectorAll(".exam-scheme-text");
            if (tabables.length > 0) {
              clearInterval(interval);
              resolve(tabables);
            }
          }, 50);
        });
      };

      waitForTabables().then((tabables) => {
        if (!this.certId) {
          tabables[0].focus();
        } else {
          const selectedCertTabable = document.getElementById(`cert-${this.certId}-${this.selectedSyllabus}`);
          selectedCertTabable.focus();
        }
      });
    },
    focusOnNext(elem) {
      elem.stopPropagation();
      const tabables = document.querySelectorAll(".exam-scheme-text");
      var index = -1;
      tabables.forEach((value, searchIndex) => {
        if (value == elem.target) {
          index = searchIndex;
        }
      });
      index += 1;
      if (index == tabables.length) {
        index = 0;
      }

      tabables[index].focus();
    },
    focusOnPrevious(elem) {
      elem.stopPropagation();
      const tabables = document.querySelectorAll(".exam-scheme-text");

      var index = 0;
      tabables.forEach((value, searchIndex) => {
        if (value == elem.target) {
          index = searchIndex;
        }
      });
      index -= 1;
      if (index == -1) {
        index = tabables.length - 1;
      }

      tabables[index].focus();
    },
  },
  computed: {
    certificateTextfieldValue() {
      if (this.selectedCertificate) {
        if (this.selectedSyllabus && Object.keys(this.selectedCertificate.syllabi).length > 1) {
          return this.certId + " - " + this.selectedCertificate.shortname + ", Syllabus " + this.selectedSyllabus;
        }
        return this.certId + " - " + this.selectedCertificate.shortname;
      }
      return null;
    },
    examPreloaded() {
      return this.$store.getters["registration/examPreloaded"];
    },
    logo: {
      get() {
        return this.$store.getters["registration/logo"];
      },
      set(value) {
        this.$store.dispatch("registration/updateLogo", value);
      },
    },
    selectedCertificate: {
      get() {
        return this.$store.getters["registration/certificate"];
      },
      set(value) {
        this.$store.dispatch("registration/updateCertificate", value);
      },
    },
    requiredResources: {
      get() {
        return this.$store.getters["registration/requiredResources"];
      },
      set(value) {
        this.$store.dispatch("registration/updateRequiredResources", value);
      },
    },
    selectedSyllabus: {
      get() {
        return this.$store.getters["registration/syllabus"];
      },
      set(value) {
        this.$store.dispatch("registration/updateSyllabus", value);
      },
    },
    certId: {
      get() {
        return this.$store.getters["registration/certId"];
      },
      set(value) {
        this.$store.dispatch("registration/updateSelectedCertId", value);
      },
    },
    certificateExpired: {
      get() {
        return this.$store.getters["registration/certificateExpired"];
      },
      set(value) {
        this.$store.dispatch("registration/updateCertificateExpired", value);
      },
    },
    selectedCountry: {
      get() {
        return this.$store.getters["registration/country"];
      },
      set(value) {
        this.$store.dispatch("registration/updateCountry", value);
      },
    },
  },
  watch: {
    menu(val) {
      if (!val) {
        this.$refs.certSelectorDropdown.$children[1].$el.scrollTop = 0;
      }
    },
  },
};
</script>

<style scoped>
.certificate-select-button {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: none;
  border-radius: 4px;
  padding: 7px 12px;
  background-color: white;
  cursor: pointer;
  margin-bottom: 24px;
  color: #000000de;
}
.certificate-select-button .v-icon {
  color: #0000008a;
}
.certificate-select-button:disabled {
  color: #00000061;
  cursor: unset;
}
.certificate-select-button:disabled .v-icon {
  color: #00000061;
}
.grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, 290px);
  grid-gap: 20px 5px;
  justify-content: left;
  align-items: top;
}
.vertical-center {
  vertical-align: middle;
}
.exam-owner-text {
  font-size: 18px;
  font-weight: bold;
  color: black;
}
.exam-scheme-text {
  margin-left: 20px;
  padding: 6px 0px;
  font-size: 15px;
  color: black;
}
.exam-scheme-text:hover,
.exam-scheme-text:active,
.exam-scheme-text:focus {
  color: #9e9e9e;
  cursor: pointer;
  outline: none;
}
.exam-logo {
  width: 50px;
  height: auto;
  margin-right: 5px;
}
.exam-logo-container {
  height: 50px;
  display: flex;
  align-items: center;
}
.v-menu__content {
  background: #fff;
}
.v-card {
  padding: 1.5rem;
}
.select.focused {
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14),
    0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
}

.select-cursor ::v-deep input {
  cursor: pointer !important;
}

.noselect ::v-deep input {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.select-cursor ::v-deep .v-input__slot {
  cursor: pointer !important;
}

.input-error ::v-deep .v-input__slot {
  box-shadow: 0px 3px 1px -2px rgba(240, 64, 79, 0.2), 0px 2px 2px 0px rgba(240, 64, 79, 0.2),
    0px 1px 5px 0px rgba(240, 64, 79, 0.2) !important;
}

.dropdown {
  cursor: default;
}

.exam-scheme-text--selected {
  background-color: #f5f5f5;
  color: #000000de;
  font-weight: bold;
  border-radius: 4px;
}
.exam-scheme-text--selected {
  border-radius: 0px;
  background-color: #f5f5f5;
  color: #1976d2 !important;
  caret-color: #1976d2 !important;
  background-color: #dce9f8 !important;
  padding-left: 1rem;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
